import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChartColumn, faClock } from '@fortawesome/pro-regular-svg-icons';
import { faLink } from '@fortawesome/pro-solid-svg-icons';
import { HomeConnectedConnectionViewModel } from '../home.models';

@Component({
  selector: 'app-home-connections-section',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule],
  templateUrl: './home-connections-section.component.html',
})
export class HomeConnectionsSectionComponent {
  @Input() totalCount = 0;
  @Input() connectedCount = 0;
  @Input() disconnectedCount = 0;
  @Input() comingSoonCount = 0;
  @Input() connectedConnections: HomeConnectedConnectionViewModel[] = [];

  @Output() manageConnection = new EventEmitter<string>();

  readonly faChartColumn = faChartColumn;
  readonly faLink = faLink;
  readonly faClock = faClock;
}
